import React from 'react';
import type {ThoughtChainItem} from '@ant-design/x';
import {ThoughtChain} from '@ant-design/x';
import {Button, Card, Space} from 'antd';
import {CheckCircleOutlined, InfoCircleOutlined, LoadingOutlined} from '@ant-design/icons';

function getStatusIcon(status: ThoughtChainItem['status']) {
  switch (status) {
    case 'success':
      return <CheckCircleOutlined />;
    case 'error':
      return <InfoCircleOutlined />;
    case 'pending':
      return <LoadingOutlined />;
    default:
      return undefined;
  }
}

const mockServerResponseData: ThoughtChainItem[] = [
  {
    title: '图纸导入',
    status: 'success',
    description: (
      <Space direction={"vertical"}>
        <span>status: success</span>
        <span>status: success</span>
        <span>status: success</span>
        <span>status: success</span>
      </Space>
    ),
    icon: getStatusIcon('success'),
  },
  {
    title: 'BOM导入',
    status: 'success',
    description: (
      <Space direction={"vertical"}>
        <span>status: success</span>
        <span>status: success</span>
        <span>status: success</span>
        <span>status: success</span>
      </Space>
    ),
    icon: getStatusIcon('success'),
  },
  {
    title: '图纸分析',
    status: 'success',
    description: 'status: success',
    icon: getStatusIcon('success'),
  },
  {
    title: 'BOM比对',
    status: 'success',
    description: 'status: success',
    icon: getStatusIcon('success'),
  },
  {
    title: '错误数据处理',
    status: 'success',
    description: 'status: success',
    icon: getStatusIcon('success'),
  },
  {
    title: '下发图纸',
    status: 'success',
    description: 'status: success',
    icon: getStatusIcon('success'),
  },
  {
    title: '工序编排',
    status: 'success',
    description: 'status: success',
    icon: getStatusIcon('success'),
  },
  // {
  //   title: 'Thought Chain Item - 2',
  //   status: 'error',
  //   description: 'status: error',
  //   icon: getStatusIcon('error'),
  // },
];

const delay = (ms: number) => {
  return new Promise<void>((resolve) => {
    const timer: NodeJS.Timeout = setTimeout(() => {
      clearTimeout(timer);
      resolve();
    }, ms);
  });
};

function addChainItem() {
  mockServerResponseData.push({
    title: `Thought Chain Item - ${mockServerResponseData.length + 1}`,
    status: 'pending',
    icon: getStatusIcon('pending'),
    description: 'status: pending',
  });
}

async function updateChainItem(status: ThoughtChainItem['status']) {
  await delay(800);
  mockServerResponseData[mockServerResponseData.length - 1].status = status;
  mockServerResponseData[mockServerResponseData.length - 1].icon = getStatusIcon(status);
  mockServerResponseData[mockServerResponseData.length - 1].description = `status: ${status}`;
}

const BubbleListRender = (props) => {
  const {robot} = props;
  const [items, setItems] = React.useState<ThoughtChainItem[]>(mockServerResponseData);
  const [loading, setLoading] = React.useState<boolean>(false);

  const mockStatusChange = async () => {
    await updateChainItem('error');
    setItems([...mockServerResponseData]);
    await updateChainItem('pending');
    setItems([...mockServerResponseData]);
    await updateChainItem('success');
    setItems([...mockServerResponseData]);
  };

  const onClick = async () => {
    setLoading(true);
    addChainItem();
    setItems([...mockServerResponseData]);
    await mockStatusChange();
    setLoading(false);
  };

  return (
    <Card style={{ width: 500 }}>
      <Button onClick={onClick} style={{ marginBottom: 16 }} loading={loading}>
        {loading ? 'Running' : 'Run Next'}
      </Button>
      <ThoughtChain items={items} />
    </Card>
  );
};
export default BubbleListRender;
